import React from 'react';
import { DadosHistoricos } from './counter/DadosHistoricos';
export const HomeStatusSection = () => {
	return (
		<div className="container-fluid">
			<div className="row">
				<h1 className="col text-center text-primary font-weight-bold py-5">
					Nossos números, clientes e parceiros
				</h1>
			</div>
			<DadosHistoricos />
		</div>
	);
};
